import React, { useState } from "react";
import MarketingHeader from "../components/argus/MarketingHeader";
import Footer from "../components/argus/Footer";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function Abuse() {
  const [form, setForm] = useState({ target: "", description: "", reporter_email: "" });
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/abuse", form);
      setSubmitted(true);
      toast.success("Report received. Scans against this target are paused for review.");
    } catch (ex) {
      toast.error(ex?.response?.data?.detail || "Couldn't send your report. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-paper text-ink min-h-screen flex flex-col">
      <MarketingHeader />
      <section className="flex-1 mx-auto max-w-2xl w-full px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-display text-5xl tracking-tight" data-testid="abuse-title">Report Abuse.</h1>
        <p className="mt-3 text-ink/70 max-w-xl">
          If an ArgusSecure account is scanning your systems without authorization, tell us here. We'll pause the account
          immediately while we investigate.
        </p>

        {submitted ? (
          <div className="mt-10 rounded-xl bg-safe/10 border border-safe/30 p-8" data-testid="abuse-success">
            <h2 className="font-display text-2xl text-safe mb-2">Got it. We're on it.</h2>
            <p className="text-sm text-ink/70">Your report is in our queue and any active scans matching this target are paused. Expect an update within one business day.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-5 rounded-xl border border-line bg-panel p-6 md:p-8" data-testid="abuse-form">
            <div>
              <Label htmlFor="target">Target URL or hostname being scanned</Label>
              <Input id="target" required value={form.target} onChange={change("target")} className="h-12 mt-1 font-mono" placeholder="https://example.com" data-testid="abuse-target" />
            </div>
            <div>
              <Label htmlFor="email">Your email (optional)</Label>
              <Input id="email" type="email" value={form.reporter_email} onChange={change("reporter_email")} className="h-12 mt-1" placeholder="security@yourcompany.com" data-testid="abuse-email" />
            </div>
            <div>
              <Label htmlFor="desc">What's happening?</Label>
              <Textarea id="desc" required minLength={20} value={form.description} onChange={change("description")} className="min-h-[140px] mt-1" placeholder="Share request logs, timestamps, anything that helps." data-testid="abuse-desc" />
            </div>
            <Button type="submit" disabled={busy} className="h-12 bg-gold text-paper hover:bg-gold2 font-semibold" data-testid="abuse-submit">
              <Send size={16} className="mr-2" /> {busy ? "Sending…" : "Send Report"}
            </Button>
          </form>
        )}
      </section>
      <Footer />
    </div>
  );
}
